import React from 'react';
import viewReadyTracker from '../../services/ViewReadyTracker';
import styles from './autoSubmit.scss';

class AutoSubmit extends React.PureComponent {
    componentDidMount() {
        viewReadyTracker.getReporter()(true);
    }

    render() {
        return (
            <div className={styles.autoSubmitWrapper} role="main">
                <div className="fa fa-spinner fa-pulse fa-3x fa-fw" />
            </div>
        );
    }
}

export default AutoSubmit;
